module.exports = __webpack_public_path__ + "static/media/darkMore.70c2aac9.svg";